export const MOXIE_PARTNER_PORTAL_LOGIN_URL =
  'https://clients.digitalcowboy.io/login';

export const AUTHORITY_BUILDER_LOGIN_URL =
  'https://authoritybuilder.digitalcowboy.io/#/login';